// 入库纯函数（EP-006 / GDD 03 §②-2.1）。
// 已存在 giftId → count += 1（firstObtainedAt 不变）；不存在 → 新增 stack（count=1）。
// 返回新数组，排序：firstObtainedAt 升序，相同时间戳按 giftId 字典序（GDD 03 §2.2）。
// 本文件不接触 lastSettledTripId（闸门只由 settleTrip.ts 关）。
import type { InventoryStackV1 } from '../save/types';

export interface AddStack {
  giftId: string;
  count: number;
}

export function addToInventory(
  inventory: InventoryStackV1[],
  stacks: AddStack[],
  now: number,
): InventoryStackV1[] {
  const map = new Map<string, InventoryStackV1>();
  for (const s of inventory) map.set(s.giftId, { ...s });

  for (const { giftId, count } of stacks) {
    const existing = map.get(giftId);
    if (existing) {
      existing.count += count;
      // 累加时 isRead 保持原值
    } else {
      map.set(giftId, { giftId, count, firstObtainedAt: now, isRead: false });
      // 🆕 v2.1：新入库礼物标记为未读
    }
  }

  return [...map.values()].sort((a, b) => {
    if (a.firstObtainedAt !== b.firstObtainedAt) return a.firstObtainedAt - b.firstObtainedAt;
    if (a.giftId < b.giftId) return -1;
    if (a.giftId > b.giftId) return 1;
    return 0;
  });
}
